import { Filter } from "@/shared/lib/filter/filter";
import { backendApi } from "../../api";
import { GesecResource } from "../types/gesec-resource";
import { ODataList } from "./odata-list";

const resourceApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    businessCentralGesecResourceShow: build.query<
      GesecResource,
      ShowGesecResourceRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/resource`,
        method: "GET",
        params: request,
      }),
    }),
    businessCentralGesecResourceList: build.query<
      ODataList<GesecResource>,
      ListGesecResourceRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/resource/list`,
        method: "GET",
        params: { request: btoa(JSON.stringify(request)) },
      }),
    }),
  }),
});

export const {
  useBusinessCentralGesecResourceShowQuery,
  useBusinessCentralGesecResourceListQuery,
} = resourceApi;

export type ShowGesecResourceRequest = {
  companyId: string;
  no: string;
};

export type ListGesecResourceRequest = {
  companyId: string;
  name?: Filter<string>;
  limit?: number;
};
